import React, { useContext, useMemo } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { AppContext } from "../Auth/contexts/AppContext";

dayjs.extend(utc);
dayjs.extend(timezone);

const GlobalTGIHistory = ({ RecordHistory }) => {
    const appContext = useContext(AppContext);
    const { userTZ } = appContext;

    const records = useMemo(() => {
        if (!RecordHistory) return [];
        try { return JSON.parse(RecordHistory); }
        catch { return []; }
    }, [RecordHistory]);

    const chartHeight = 60;
    const chartWidth = 270;
    const totalDays = 180;

    const startDate = dayjs().tz(userTZ).startOf('day').subtract(totalDays - 1, 'day');
    const dayWidth = chartWidth / totalDays;

    const chartData = useMemo(() => {
        if (!records.length) return [];

        const sorted = [...records].sort((a, b) =>
            dayjs.utc(a.updated_at).valueOf() - dayjs.utc(b.updated_at).valueOf()
        );

        const changeEvents = [];
        let lastTGI = null;
        for (const r of sorted) {
            const val = parseFloat(r.GlobalTGI);
            if (val !== lastTGI) {
                const date = dayjs.utc(r.updated_at).tz(userTZ).startOf('day');
                if (!date.isBefore(startDate)) {
                    changeEvents.push({
                        date: date.format('YYYY-MM-DD'),
                        value: val,
                        dayIndex: date.diff(startDate, 'day')
                    });
                }
                lastTGI = val;
            }
        }

        return changeEvents;
    }, [records, userTZ]);

    const scaleMax = useMemo(() => {
        if (!chartData.length) return 1;
        const maxVal = Math.max(...chartData.map(d => d.value));
        return Math.max(maxVal, 1);
    }, [chartData]);

    return (
        <div className="chart-container">
            <svg width={chartWidth} height={chartHeight + 2}>
                {chartData.map((point) => {
                    const barHeight = (point.value / scaleMax) * chartHeight;
                    const x = point.dayIndex * dayWidth;
                    const y = chartHeight - barHeight;

                    return (
                        <rect
                            key={point.date}
                            x={x}
                            y={y}
                            width={Math.max(dayWidth * 2, 3)}
                            height={barHeight}
                            fill="#225fc4"
                        >
                            <title>{`${point.date}: $${point.value}`}</title>
                        </rect>
                    );
                })}

                <line x1="0" y1={chartHeight} x2={chartWidth} y2={chartHeight} stroke="#DDD" strokeWidth="1" />
                <line x1="0" y1="0" x2="0" y2={chartHeight} stroke="#DDD" strokeWidth="1" />
            </svg><br />
        </div>
    );
};

export default GlobalTGIHistory;